import axios from 'axios';

/**
 * Obtiene el token de acceso desde el backend local o el flujo de autenticación del sistema.
 * Nota: En este proyecto el access_token se guarda en localStorage.
 */
const getAccessToken = () => localStorage.getItem('access_token');
const getApiUrl = () => process.env.REACT_APP_API_URL_DEV;

/**
 * Tokenizar tarjeta
 * POST /cardToken/add
 */
export const tokenizeCard = async (cardData) => {
    const apiUrl = getApiUrl();
    const token = getAccessToken();
    
    try {
        const response = await axios.post(`${apiUrl}/cardToken/add`, cardData, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data; // { status, requestId, dataResponse: { id, creationDate } }
    } catch (error) {
        console.error('Error in tokenizeCard:', error);
        throw error;
    }
};

/**
 * Crear plan recurrente
 * POST /recurrentPurchase/add
 */
export const createRecurringPlan = async (planData) => {
    const apiUrl = getApiUrl();
    const token = getAccessToken();
    
    try {
        const response = await axios.post(`${apiUrl}/recurrentPurchase/internal/add`, planData, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data; // { status, dataResponse: { id, detail: [...] } }
    } catch (error) {
        console.error('Error in createRecurringPlan:', error);
        throw error;
    }
};

/**
 * Realizar cargo inicial (Pasarela)
 * POST /ecommerce/charge
 */
export const chargeInitialPayment = async (chargeData) => {
    const apiUrl = getApiUrl();
    const token = getAccessToken();
    
    try {
        const response = await axios.post(`${apiUrl}/ecommerce/charge`, chargeData, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data; // { status, requestId, id, dataResponse: { authorization, description, ... } }
    } catch (error) {
        console.error('Error in chargeInitialPayment:', error);
        throw error;
    }
};

/**
 * Cancelación de cargo (Plan Recurrente)
 * POST /recurrentPurchase/internal/delete/{id}
 */
export const cancelCharge = async (chargeId) => {
    const apiUrl = getApiUrl();
    const token = getAccessToken();
    
    try {
        const response = await axios.post(`${apiUrl}/recurrentPurchase/internal/delete/${chargeId}`, {}, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error('Error in cancelCharge:', error);
        throw error;
    }
};

/**
 * Obtener lista de planes recurrentes desde la API real
 */
export const fetchRecurringPayments = async (page = 1, limit = 50) => {
    const apiUrl = getApiUrl();
    const token = getAccessToken();
    
    try {
        const response = await axios.get(`${apiUrl}/recurrentPurchase?page=${page}&limit=${limit}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data; // { data: [...], pagination: { ... } }
    } catch (error) {
        console.error('Error in fetchRecurringPayments:', error);
        throw error;
    }
};
